<template>
  <button
    type="button"
    tabindex="0"
    class="convo-search-link selection-tile size-tile"
  >
    <span
      :class="['icon', { 'color-facet-icon': isColorFacet }]"
      :style="{ 'background': tileBg }"
      aria-hidden="true"
    />
    <span>
      {{ value }}
    </span>
  </button>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
});

function getColorKey(color) {
  return color ? color.split('/')[0] : color;
}

const isColorFacet = ref(props.name === 'COLOR_NORMAL');
const tileBg = ref(isColorFacet.value ? `var(--filtering-facets-color-gradient-${getColorKey(props.value)?.toLowerCase()})` : 'none');

</script>

<style lang="scss" scoped>

.selection-tile.size-tile {
  width: auto;
  flex: 0 0 auto;
  padding: 0 0.75rem;
  text-decoration: none;
}

.color-facet-icon {
  display: block;
}

.convo-search-link {
  margin-right: 1rem;
  flex-direction: row;
  .icon {
    display: none;
  }

  .color-facet-icon {
    display: block;
    border-radius: 50%;
    margin-right: 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
    border: 1px solid var(--macys-gray-1, #626369);
  }
}
</style>
